import {
  ReorderableElement,
  ReorderableList,
} from '@monorepo/shared/componentsV2/dragAndDrop/ReorderableList';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useFormTemplateContext } from '../EditFormTemplatePage/FormTemplateContext';
import { FormTemplateSection } from './FormTemplateSection';

const StyledReorderableList = styled(ReorderableList)`
  margin-top: 0;
  margin-bottom: 0.25em;
`;

const StyledFormTemplateSection = styled(FormTemplateSection)`
  margin: 0;

  /* so elements aren't see-through while being dragged over one another  */
  background-color: ${({ theme }) => theme.colors.white};
`;

interface ReorderableFormTemplateGroupsProps {
  activeGroupSlug?: string;
  isEditingDisabled: boolean;
}

export function ReorderableFormTemplateGroupsList({
  activeGroupSlug,
  isEditingDisabled,
}: ReorderableFormTemplateGroupsProps) {
  const {
    formTemplate,
    formTemplateHelpers: { setActiveGroupSlug, updateGroupOrder },
  } = useFormTemplateContext();
  const sortedFormTemplateGroups = useMemo(
    () => formTemplate?.groups || [],
    [formTemplate],
  );

  const orderedElements: ReorderableElement[] = useMemo(
    () =>
      sortedFormTemplateGroups.map((section) => ({
        id: section.slug,
        component: (
          <StyledFormTemplateSection
            name={section.name}
            clickHandler={() => setActiveGroupSlug(section.slug)}
            isDuplicable={section.isDuplicable}
            isActive={activeGroupSlug === section.slug}
          />
        ),
      })),
    [sortedFormTemplateGroups, setActiveGroupSlug, activeGroupSlug],
  );

  return (
    <StyledReorderableList
      orderedElements={orderedElements}
      onOrderChange={updateGroupOrder}
      uniqueDragListId="reorderableFormGroups"
      listAriaLabel="Reorderable Form Sections"
      disableDragging={isEditingDisabled}
    />
  );
}
